/** Client metadata sent to Cognito pre-auth triggers for login audit logs. */
export async function getLoginClientMetadata(): Promise<{ [key: string]: string }> {
  let ip_address = '';
  try {
    // Browser has no native public IP — use a small service or your own endpoint
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    ip_address = data.ip || '';
  } catch {
    // Best-effort; login should still proceed without IP
  }
  return {
    ip_address,
    user_agent: navigator.userAgent || '',
  };
}
